export interface IExceptionMetadata {
  fileName: string;
  methodName: string;
  exceptionCategory: string;
  exceptionMessage: string;
}

export interface ITrackJs {
  addMetadata(key: string, value: string): void;

  removeMetadata(key: string): void;

  track(key: string): void;
}
